import React from 'react';  // eslint-disable-line

const CloseX = () => {
    return (
        <svg width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Admin-CMS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Components-/-Alert-/-Toast-/-Info-Copy" transform="translate(-271.000000, -18.500000)">
                    <g id="Icon" transform="translate(269.000000, 16.000000)">
                        <polygon id="Shape" points="0 0 16 0 16 16 0 16" />
                        <path d="M9.58652479,8 L13.1772476,4.40938944 C13.3849175,4.20172601 13.3849175,3.86473128 13.1772476,3.65673453 L12.3429012,2.82241423 C12.1352313,2.61475081 11.798226,2.61475081 11.5902228,2.82241423 L7.99983333,6.41335812 L4.40911056,2.82274756 C4.20144065,2.61508414 3.86443538,2.61508414 3.65643213,2.82274756 L2.8224191,3.65673453 C2.61474919,3.86439795 2.61474919,4.20139269 2.8224191,4.40938944 L6.41314187,8 L2.8224191,11.5906106 C2.61474919,11.798274 2.61474919,12.1352687 2.8224191,12.3432655 L3.65676547,13.1775858 C3.86443538,13.3852492 4.20144065,13.3852492 4.4094439,13.1775858 L7.99983333,9.58664188 L11.5905561,13.1772524 C11.798226,13.3849159 12.1352313,13.3849159 12.3432345,13.1772524 L13.1775809,12.3429321 C13.3852508,12.1352687 13.3852508,11.798274 13.1775809,11.5902772 L9.58652479,8 Z" id="Path" fill="#176BFB" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default CloseX;
